import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center px-4 bg-background-50">
      <div className="text-center">
        <div className="w-24 h-24 flex items-center justify-center mx-auto mb-6 rounded-full bg-primary-100">
          <i className="ri-movie-2-line text-5xl text-primary-500"></i>
        </div>
        <h1 className="font-heading text-6xl md:text-8xl font-black text-foreground-900 mb-4">
          404
        </h1>
        <p className="text-lg text-foreground-500 mb-8">
          哎呀，这个页面走丢了... 就像一部未上映的电影
        </p>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line mr-2"></i>
          返回首页
        </Link>
      </div>
    </main>
  );
}